import { OnboardingContentWrapper } from "components/Docs/OnboardingContentWrapper";
import { TraceEvent } from "onboarding/llm-analytics/_snippets/trace-event.tsx";
import * as React from 'react';
export default {
  OnboardingContentWrapper,
  TraceEvent,
  React
};